import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import {FiX} from '../../assets/icons/vander'

export default function BusinessCta() {
    let [show, setShow] = useState(false)
  return (
    <>
      <section className="section bg-light">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 text-center">
                        <div className="section-title">
                            <h4 className="title mb-4">Do you gave any questions about Leaping</h4>
                            <p className="text-muted para-desc mx-auto">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                            <Link to="#" onClick={()=>setShow(!show)} className="btn btn-outline-primary mt-3">Free Trial</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div className={`modal fade  ${show ? 'show d-block' : ''}`} id="LoginForm" style={{backgroundColor:'#00000099'}}>
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalCenterTitle">Free Trial For 15 Days</h5>
                        <button type="button" className="btn btn-icon btn-close" onClick={()=>setShow(!show)}><i className="fs-4 text-dark"><FiX/></i></button>
                    </div>
                    <div className="modal-body">
                        <div className="bg-white p-3 rounded box-shadow">
                            <form className="login-form">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-3 position-relative">                                               
                                            <label className="form-label">First name <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" placeholder="First Name" name="s" required=""/>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="mb-3 position-relative">
                                            <label className="form-label">Your Email <span className="text-danger">*</span></label>
                                            <input type="email" className="form-control" placeholder="Email" name="email" required=""/>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="mb-3 position-relative">
                                            <label className="form-label">Phone No. <span className="text-danger">*</span></label>
                                            <input type="number" id="number" className="form-control" placeholder="Phone :" required=""/>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="mb-3">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                                <label className="form-check-label" htmlFor="flexCheckDefault">I Accept <Link to="#" className="text-primary">Terms And Condition</Link></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <button className="btn btn-primary w-100">Register</button>
                                    </div>
                                    <div className="col-lg-12 mt-4 text-center">
                                        <h6>Or Signup With</h6>
                                        <ul className="list-unstyled social-icon mb-0 mt-3">
                                            <li className="list-inline-item m-x-2"><Link to="#" className="rounded"><i className="mdi mdi-facebook" title="Facebook"></i></Link></li>
                                            <li className="list-inline-item m-x-2"><Link to="#" className="rounded"><i className="mdi mdi-google-plus" title="Google"></i></Link></li>
                                            <li className="list-inline-item m-x-2"><Link to="#" className="rounded"><i className="mdi mdi-github" title="Github"></i></Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}
